import Flag from '@atom-web/icons-24/jsx/Flag'
import { Box, Column, Row, Text } from '@atom-web/micros'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useEffect, useMemo } from 'react'
import ReactPlayer from 'react-player'

import { AppConfig } from '../../../../app-config'
import customImageLoader from '../../../../utils/customImageLoader'
import getImgIXUrl from '../../../../utils/getImgIXUrl'
import GcmComponent from './GCMComponent'

export default ({ data, isMobile }) => {
	const maldivesVideo = useMemo(
		() => ({
			videoUrl: `https:${AppConfig.images_cdn_url_s3}web_app/speed-boat/video/mle_video_desktop.mp4`,
			poster: getImgIXUrl(
				'https://pyt-images.imgix.net/images/web_app/speed-boat/video/mle-poster.jpg',
				'h=480',
			),
		}),
		[data],
	)
	const router = useRouter()
	const playVideo = () => {
		const videoElement = document.getElementsByClassName(
			'react-player__play-icon',
		)[0]
		videoElement && videoElement.click()
	}

	useEffect(() => {
		playVideo()
	}, [])
	return (
		<Box
			css={{
				position: 'relative',
			}}
		>
			<Column
				css={{
					position: 'absolute',
					top: 0,
					width: '100%',
					height: '36px',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 99999,
				}}
			>
				<Image
					src={getImgIXUrl(
						`${AppConfig.images_cdn_url_s3}web_app/speed-boat/alert-bg.png`,
					)}
					loader={customImageLoader}
					layout="fill"
					priority
				/>
				<Row
					gap="1"
					css={{
						zIndex: 99999,
						alignItems: 'center',
					}}
				>
					<Flag fill="#01C684" />
					<Text
						css={{
							fontSize: '$3',
							lineHeight: '1.5',
							letterSpacing: '-0.25px',
							color: 'rgb(83, 87, 109)',
						}}
					>
						{isMobile
							? 'Lightning deals exclusively for you'
							: 'Lightning deals exclusively for you. Book your trip to Maldives at the cheapest price!'}
					</Text>
				</Row>
			</Column>
			<Column
				justify={'center'}
				align="center"
				css={{
					height: '480px',
					width: '100%',
					marginTop: '32px',
					'&::after': {
						position: 'absolute',
						content: '',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						background:
							'linear-gradient(180deg,transparent 55%,rgba(0,0,0,.85))',
					},
					'@smMax': {
						height: '80vh',
						width: '100%',
						'&::after': {
							position: 'absolute',
							content: '',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							background: 'linear-gradient(180deg,transparent,rgba(0,0,0,.6))',
						},
					},
				}}
			>
				<ReactPlayer
					url={[{ src: maldivesVideo.videoUrl, type: 'video/mp4' }]}
					light={maldivesVideo.poster}
					playing={true}
					loop={true}
					width="100%"
					height="100%"
					className={'maldives-videos'}
					muted
				/>
			</Column>

			<Column
				gap="6"
				css={{
					width: '100%',
					position: 'absolute',
					top: '35%',
					alignItems: 'center',
					zIndex: 99,
					textAlign: 'center',
					'@smMax': {
						top: '55%',
					},
				}}
			>
				<Text
					as="h1"
					css={{
						fontSize: '44px',
						fontWeight: '$bolder',
						letterSpacing: '-0.88px',
						lineHeight: '48px',
						color: '#fff',

						'@smMax': {
							fontSize: '38px',
							letterSpacing: '-0.76px',
							lineHeight: '40px',
						},
					}}
				>
					Book your dream trip to Maldives
				</Text>
			</Column>
			<GcmComponent data={data} />
		</Box>
	)
}
